import React from 'react';

type IconProps = {
    width?: number;
    height?: number;
    color?: string;
};

const IconRemoveBackground: React.FC<IconProps> = ({
    width = 18,
    height = 21,
    color = 'black',
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            viewBox="0 0 18 21"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.6582 9.30143C16.6582 8.0356 15.7568 7.00977 14.6445 7.00977H7.32223C6.20997 7.00977 5.30859 8.0356 5.30859 9.30143V17.6348C5.30859 18.9006 6.20997 19.9264 7.32223 19.9264H14.6445C15.7568 19.9264 16.6582 18.9006 16.6582 17.6348V9.30143ZM15.5598 9.30143V17.6348C15.5598 18.2098 15.1498 18.6764 14.6445 18.6764H7.32223C6.81699 18.6764 6.40694 18.2098 6.40694 17.6348V9.30143C6.40694 8.72643 6.81699 8.25977 7.32223 8.25977H14.6445C15.1498 8.25977 15.5598 8.72643 15.5598 9.30143Z"
                fill={color}
            />
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M4.57717 12.4773L2.4764 14.8681C2.62211 14.9064 2.77368 14.9264 2.92965 14.9264H4.57717V12.4773ZM4.80636 8.04977L0.916016 12.4773V12.6348C0.916016 13.2548 1.13202 13.8173 1.48349 14.2298L4.57717 10.7089V9.30143C4.57717 8.85643 4.65918 8.43227 4.80636 8.04977ZM8.55977 2.00977L0.916016 10.7089V8.3106L6.45241 2.00977H8.55977ZM4.89862 2.00977H2.92965C1.81739 2.00977 0.916016 3.0356 0.916016 4.30143V6.54227L4.89862 2.00977ZM6.22322 6.43727C6.55932 6.26977 6.93202 6.17643 7.32303 6.17643H8.55977L11.6534 2.6556C11.291 2.2556 10.7967 2.00977 10.252 2.00977H10.1136L6.22322 6.43727ZM10.1136 6.17643H12.2656V4.30143C12.2656 4.12393 12.248 3.95143 12.2143 3.7856L10.1136 6.17643Z"
                fill={color}
            />
        </svg>
    );
};

export default IconRemoveBackground;
